import React from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import ReferralProgramComponent from '../../components/referrals/ReferralProgram.component'
import PageHeading from '../../components/shared/PageHeading.component'
import { MDBContainer } from 'mdb-react-ui-kit'

import './ReferralProgram.page.scss'

class ReferralProgramPage extends React.Component {
  render() {
    return (
      <DashboardLayout>
        <main id='ReferralProgramPage' className='mainSection pb-5'>
          <MDBContainer fluid className='mt-4'>
            <PageHeading
              label='Referral Program'
              url={this.props?.match?.url}
              from={this.props?.location?.state?.from}
              goTo={url => this.props.history.push(url, { from: '/admin-referrals' })}
            />
            <ReferralProgramComponent />
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default ReferralProgramPage
